import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 保存类型
 */
class SaveType extends UltMeta {
    SAVE_TO_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_COMMIT = new Meta(2, "保存并提交");
}

export const SAVE_TYPE = new SaveType();

/**
 * 供应链端查询枚举
 */
class QueryState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    PENDING_REVIEW = new Meta(2, "待审核");
    REVIEWING = new Meta(3, "审核中");
    PENDING_CONFIRMATION = new Meta(4, "待确认");
    CONFIRMING = new Meta(5, "确认中");
    REJECTED = new Meta(6, "已驳回");
    INBOUNDED = new Meta(7, "已入库");
    INVALIDATING = new Meta(8, "作废中");
    INVALIDATED = new Meta(9, "已作废");
}

export const QUERY_STATE = new QueryState();

/**
 * 实际后端定义返回入库管理状态 可用于 客户端查询枚举
 */
class State extends UltMeta {
    DRAFT = new Meta(1, "草稿", QUERY_STATE.DRAFT.code);
    // 待审核/审核中
    PENDING_REVIEW = new Meta(2, "审核中", `${QUERY_STATE.PENDING_REVIEW.code},${QUERY_STATE.REVIEWING.code}`);
    // "待确认/确认中"
    PENDING_CONFIRMATION = new Meta(3, "确认中", `${QUERY_STATE.PENDING_CONFIRMATION.code},${QUERY_STATE.CONFIRMING.code}`);
    REJECTED = new Meta(4, "已驳回", QUERY_STATE.REJECTED.code);
    INBOUNDED = new Meta(5, "已入库", QUERY_STATE.INBOUNDED.code);
    INVALIDATING = new Meta(6, "作废中", QUERY_STATE.INVALIDATING.code);
    INVALIDATED = new Meta(7, "已作废", QUERY_STATE.INVALIDATED.code);
}

export const STATE = new State();

/**
 * 入库类型
 */
class InboundType extends UltMeta {
    PURCHASE_INBOUND = new Meta(1, "采购入库");
    REFUND_NECK_INBOUND = new Meta(2, "退领入库");
    ALLOT_INBOUND = new Meta(3, "调拨入库");
    INVENTORY_PROFIT_INBOUND = new Meta(4, "盘盈入库");
    SALES_RETURNS_INBOUND = new Meta(5, "销售退货入库");
    PLEDGE_INBOUND = new Meta(16, "质押入库");
    OTHER_INBOUND = new Meta(6, "其他入库");
}

export const INBOUND_TYPE = new InboundType();

/**
 * 发起方
 */
class Initiator extends UltMeta {
    INBOUND_PARTY = new Meta(1, "入库方");
    REGULATOR = new Meta(2, "监管方");
    ENTRUST = new Meta(3, "委托方");
}

export const INITIATOR = new Initiator();

/**
 * 确认状态
 */
class ConfirmState extends UltMeta {
    TO_BE_CONFIRM = new Meta(1, "待确认、待审核");
    CONFIRM = new Meta(2, "已确认、已审核");
    REJECT = new Meta(3, "已驳回");
}

export const CONFIRM_STATE = new ConfirmState();
